import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";
import "../CSS/ButtonStyles.css";
import "../CSS/ModalStyles.css";
import { GetResources } from "../scripts/ResourceManager.js";
import { VersionData } from './Home';

export class VersionPreviewPopupContent extends Component {
    constructor(props) {
        super(props);
        this.ExpandCollapseRecords = this.ExpandCollapseRecords.bind(this);
        this.Publish = this.Publish.bind(this);
    }

    ExpandCollapseRecords() {
        //Nthing to do
    }

    Publish(event) {
        event.target.disabled = true;
        document.getElementById("btnPublishCancel").disabled = true;
        this.props.onPublish();
    }

    render() {
        let { data, mobileData } = this.props;
        const enResources = GetResources("EN");
        const frResources = GetResources("FR");

        return (
            <div className="modal-body">
                <div className={"CA-currentVersionSection row mx-0 mt-2 mb-2 pb-2 bg-white previewEnglish"}><VersionData data={data[0]} resources={enResources} versionIndex={0} dataLength={data.length} expandCollapseClick={this.ExpandCollapseRecords} expandState={false} mobileData={mobileData} isPreview={true} /></div>
                <div className={"CA-currentVersionSection row mx-0 mt-2 mb-2 pt-3 bg-white previewFrench"}><VersionData data={data[0]} resources={frResources} versionIndex={0} dataLength={data.length} expandCollapseClick={this.ExpandCollapseRecords} expandState={false} mobileData={mobileData} isPreview={true} /></div>                {this.props.showActions ?
                    <div className="modal-footer justify-content-center">
                        <button id="btnPublishCancel" className="btn CTA-Cancel me-3" type="button" onClick={this.props.CloseDialog}>Cancel</button>
                        <button className="btn CTA-active border-0" type="button" onClick={this.Publish}>Publish</button>
                    </div> : null}
            </div>
        );
    }
}

export class NewFileTypePopupContent extends Component {
    constructor(props) {
        super(props);
        const fileTypeJsonTemplate = { "fileTypeName": "", "fileName": "", "fileUrl": "", "fileLinkDescriptionEN": "", "fileLinkDescriptionFR": "", "fileBlobName": "" };
        this.state = { fileTypeJson: fileTypeJsonTemplate };
        this.onFileTypeChange = this.onFileTypeChange.bind(this);
    }

    onFileTypeChange(event) {
        let { fileTypeJson } = this.state;
        fileTypeJson.fileTypeName = event.target.value;
        this.setState({ fileTypeJson: fileTypeJson });
    }

    render() {
        let { fileTypeName } = this.state.fileTypeJson;
        return (
            <div>
                <div className="modal-body">
                    <p className="col-12 px-0 text-center pb-3 modal-descp">Select & enter the new file type details below:</p>
                    <div className="form-group mb-4">
                        <label htmlFor="CA-fileName" className="CA-fileName">Name of the file type</label>
                        <input
                            id="CA-fileName"
                            type="text"
                            className="form-control"
                            onChange={this.onFileTypeChange}
                            value={fileTypeName}
                            autoFocus={true}
                        />
                    </div>
                </div>
                <div className="modal-footer justify-content-center">
                    <button className="btn CTA-Cancel me-3" type="button" onClick={this.props.CloseDialog}>Cancel</button>
                    <button
                        className="btn CTA-active border-0"
                        type="button"
                        disabled={!fileTypeName}
                        onClick={() => this.props.AddFileType(this.state.fileTypeJson)}
                    >
                        Add file type
                    </button>
                </div>
            </div>
        );
    }
}

export class ConfirmationPopupContent extends Component {
    constructor(props) {
        super(props);
        this.OkButton = this.OkButton.bind(this);
    }

    OkButton(event) {
        event.target.disabled = true;
        document.getElementById("btnUnpublishCancel").disabled = true;
        this.props.onOk();
    }

    render() {
        const { message, okButtonText } = this.props;
        return (
            <div>
                <div className="modal-body">
                    <p className="col-12 px-0 text-center pb-3 modal-descp" dangerouslySetInnerHTML={{ __html: message }}></p>
                </div>
                <div className="modal-footer justify-content-center">
                    <button id="btnUnpublishCancel" className="btn CTA-Cancel me-3" type="button" data-bs-dismiss="modal" onClick={this.props.onCancel} autoFocus={true}>Cancel</button>
                    <button className="btn CTA-active border-0" type="button" onClick={this.OkButton}>{okButtonText}</button>
                </div>
            </div>
        );
    }
}

export class DeletePopupContent extends Component {
    render() {
        const { deleteVersion, published } = this.props;
        var message = "Are you sure you want to delete <strong>" + deleteVersion + "</strong>" + (published ? " which is <strong>published</strong>?" : "?");
        return (
            <div>
                <div className="modal-body">
                    <p className="col-12 px-0 text-center pb-3 modal-descp" dangerouslySetInnerHTML={{ __html: message }}></p>
                </div>
                <div className="modal-footer justify-content-center">
                    <button className="btn CTA-Cancel me-3" type="button" data-bs-dismiss="modal" onClick={this.props.onClose} autoFocus={true}>Cancel</button>
                    <button className="btn CTA-active border-0" type="button" onClick={this.props.onDelete}>Delete</button>
                </div>
            </div>
        );
    }
}

export class Popup extends Component {    render() {
        const { dialogKey, dialogTitle, classNames } = this.props;
        var dialogClasses = "modal-dialog modal-dialog-centered";
        if (classNames !== "") {
            dialogClasses = classNames;
        }
        
        return (
            <div>
                <div className="modal-backdrop fade show"></div>
                <div className="modal fade show CA-modal-visible" id={dialogKey} tabIndex="-1" role="dialog" aria-labelledby={dialogKey + "Label"} aria-modal="true">
                    <div className={dialogClasses} role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id={dialogKey + "Label"}>{dialogTitle}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    onClick={this.props.onClose}></button>
                            </div>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}